import { addBrand, allBrands, deleteBrand, updateBrand } from '@/utils/request'
import vue from '@/main'

const state = {
  brandList: []
}

const mutations = {
  RESET (state) {
    state.brandList = []
  }
}

const actions = {
  all ({ state }) {
    return new Promise((resolve) => {
      allBrands().then(response => {
        state.brandList = response.data
        resolve(state.brandList)
      })
    })
  },
  brandById ({ commit, state }, id) {
    for (const team of state.brandList) {
      if (team.id === id) return vue.$_.cloneDeep(team)
    }
    return null
  },
  updateOne ({ state }, brand) {
    return new Promise((resolve) => {
      updateBrand(brand).then(() => {
        for (const cur of state.brandList) {
          if (cur.id === brand.id) {
            Object.assign(cur, brand)
            break
          }
        }
        this.dispatch('data/kvListForce', 'BrandModel')
        resolve()
      })
    })
  },
  add ({ commit, dispatch, state }, team) {
    return new Promise((resolve) => {
      addBrand(team).then((response) => {
        state.brandList.push(response.data)
        this.dispatch('data/kvListForce', 'BrandModel')
        resolve(response.data)
      })
    })
  },
  delete ({ commit, dispatch, state }, brand) {
    return new Promise((resolve) => {
      deleteBrand(brand.id).then(() => {
        for (const i in state.brandList) {
          if (state.brandList[i].id === brand.id) {
            state.brandList.splice(i, 1)
          }
        }
        this.dispatch('data/kvListForce', 'BrandModel')
        resolve()
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
